module.exports = __webpack_public_path__ + "static/media/Open-Sans-regular.953de7ba.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Open-Sans-regular/Open-Sans-regular.ttf
// module id = 416
// module chunks = 0